/* eslint-disable indent */
/* eslint-disable prefer-const */
import React, { useEffect, useState, createRef } from 'react'
import MuiAlert from '@material-ui/lab/Alert'
import { useSelector } from 'react-redux'
import { Grid, Button, Snackbar } from '@material-ui/core/'
import TablePodcast from './component/TablePodcast'
import ModalPodcast from './component/ModalPodcast'
import DeletePodcast from './component/DeletePodcast'
import useAudio from './component/useAudio'
import { podcastValue } from './constants'
import apiAdmin from '../../../../../api/admin'
import './index.scss'

const Alert = props => <MuiAlert elevation={6} variant='filled' {...props} />

const Podcasts = () => {
  const [open, setOpen] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const { user } = useSelector(({ session }) => session)
  const [podcast, setPodcast] = useState(podcastValue)
  const [podcastSrc, setPodcastSrc] = useState({
    audioSrc: '',
    imgSrc: '',
  })
  const [podcastLict, setPodcastList] = useState([])
  const [audioElement, audioProps] = useAudio(podcastSrc?.audioSrc)
  const [error, setError] = useState(false)
  const audioRef = createRef()
  const [isEditPodcast, setIsEditPodcast] = useState('')

  const openModal = () => setOpen(prev => !prev)
  const handleClose = () => {
    setIsEditPodcast('')
    setOpen(false)
    setPodcast(podcastValue)
    setPodcastSrc({
      audioSrc: '',
      imgSrc: '',
    })
  }

  const uploadImgsStorys = img => {
    apiAdmin.uploadImgsStorys(user?.accessKey, [img?.data], 2)
      .then(({ data }) => {
        setPodcast({ ...podcast, imgUiid: data?.images?.[0]?.uuid })
        setPodcastSrc({ ...podcastSrc, imgSrc: data?.images?.[0]?.src })
      })
      .catch(error => console.error(error))
  }

  const uploadAudio = file => {
    apiAdmin?.uploadFilesMail(user?.accessKey, [file])
      .then(({ data }) => {
        apiAdmin?.uploadAudioPodcast({
          src: data?.images?.[0]?.src,
          duration: 0,
          accessKey: user?.accessKey,
          listenCountDefault: podcast?.listenCountDefault,
        })
        .then(({ data }) => {
          setPodcast({ ...podcast, audioUiid: data?.podcast?.uuid })
          setPodcastSrc({ ...podcastSrc, audioSrc: data?.podcast?.src })
        })
      })
      .catch(error => console.error(error))
  }

  const handleAudioChange = (e, uplodHandler) => {
    let reader
      reader = new FileReader()
      reader.readAsDataURL(e?.target?.files?.[0])
      reader.onload = event => {
        uplodHandler({
          data: event?.target?.result,
          contentType: event?.target?.result?.split(';')?.[0]?.split(':')?.[1],
        })
      }
  }

  const onChangeValue = name => value => setPodcast({ ...podcast, [name]: value })

  const createPodcast = duration => {
    const { name, tags, audioUiid, imgUiid, listenCountDefault } = podcast
    if (name && tags && audioUiid && imgUiid && duration && listenCountDefault) {
      if (isEditPodcast) {
        apiAdmin?.editPodcast(isEditPodcast, {
          imageUuid: imgUiid,
          podcastUuid: audioUiid,
          title: name,
          hashtags: tags,
          accessKey: user?.accessKey,
          listenCountDefault: listenCountDefault,
        }).then(({ data }) => {
          apiAdmin.updatePodcastAudio(data?.story?.podcast?.uuid, user?.accessKey, Math.round(audioProps?.duration), listenCountDefault)
            .then(() => {
              getPodcast()
              setOpen(false)
              setPodcast(podcastValue)
              setPodcastSrc({
                audioSrc: '',
                imgSrc: '',
              })
              setIsEditPodcast('')
            })
        }).catch(error => console.error(error))
      } else {
        apiAdmin?.createPodcast({
          imageUuid: imgUiid,
          podcastUuid: audioUiid,
          title: name,
          hashtags: tags,
          accessKey: user?.accessKey,
          listenCountDefault: listenCountDefault,
        })
          .then(({ data }) => {
            apiAdmin.updatePodcastAudio(data?.story?.podcast?.uuid, user?.accessKey, Math.round(audioProps?.duration), listenCountDefault)
              .then(() => {
                getPodcast()
                setOpen(false)
                setPodcast(podcastValue)
                setPodcastSrc({
                  audioSrc: '',
                  imgSrc: '',
                })
              })
          })
          .catch(error => console.error(error))
      }
    } else {
      setError(true)
    }
  }

  const deletePodcast = () => {
    apiAdmin?.deletePodcast(user?.accessKey, openDelete)
      .then(() => getPodcast())
      .catch(error => console.error(error))
      .finally(() => setOpenDelete(false))
  }

  const deleteAudio = () => {
    apiAdmin?.deletePodcastAudio(user?.accessKey, podcast?.audioUiid)
      .then(() => {
          setPodcast({ ...podcast, audioUiid: '' })
          setPodcastSrc({ ...podcastSrc, audioSrc: '' })
      })
      .catch(error => console.error(error))
  }

  const getPodcast = () => {
    apiAdmin?.getPodcast(user?.accessKey)
      .then(({ data }) => setPodcastList(data?.stories))
      .catch(error => console.error(error))
  }

  const handleCloseError = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setError(false)
  }

  useEffect(() => {
    getPodcast()
  }, [])

  const uploadHandlerAudio = () => audioRef?.current?.click()

  const updatePodcast = data => {
    setIsEditPodcast(data?.uuid)
    setPodcast({
      name: data?.title,
      tags: data?.hashtags.join(' '),
      audioUiid: data?.podcast?.uuid,
      imgUiid: data?.image?.uuid,
      listenCountDefault: data?.podcast?.listenCountDefault,
    })
    setPodcastSrc({
      audioSrc: data?.podcast?.src,
      imgSrc: data?.image?.src,
    })
    setOpen(true)
  }

  const deleteImgPodcast = () => {
    setPodcast({ ...podcast, imgUiid: '' })
    setPodcastSrc({ ...podcastSrc, imgSrc: '' })
  }

  return (
    <Grid className='wrapperPodcasts'>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={error} autoHideDuration={6000} onClose={handleCloseError}>
        <Alert onClose={handleCloseError} severity='warning'>
          Fill in all the fields!
        </Alert>
      </Snackbar>
      <ModalPodcast
        open={open}
        setOpen={setOpen}
        handleAudioChange={handleAudioChange}
        uploadAudio={uploadAudio}
        uploadImgsStorys={uploadImgsStorys}
        onChangeValue={onChangeValue}
        podcastSrc={podcastSrc}
        createPodcast={createPodcast}
        handleClose={handleClose}
        deleteAudio={deleteAudio}
        audioElement={audioElement}
        audioProps={audioProps}
        uploadHandlerAudio={uploadHandlerAudio}
        audioRef={audioRef}
        podcast={podcast}
        deleteImgPodcast={deleteImgPodcast}
      />
      <DeletePodcast open={openDelete} setOpen={setOpenDelete} deletePodcast={deletePodcast} />
      <Button
        className='btnAddMail'
        variant='contained'
        color='primary'
        onClick={() => setOpen(true)}
      >
        ADD PODCAST
      </Button>
      <TablePodcast updatePodcast={updatePodcast} openModal={openModal} podcastLict={podcastLict} setOpenDelete={setOpenDelete} />
    </Grid>
  )
}

export default Podcasts
